<template>
	<div>
		<!-- 导航条 -->
		<BaseNav></BaseNav>

		<!-- 弹窗广告 -->
		<div class="advert" v-if="jumpImageList[0]['linkType']==1 && showAdvert == true">
			<a target="_blank" :href="jumpImageList[0]['linkUrl']">
				<img :src="imagePath + jumpImageList[0]['imageUrl']" alt="">
			</a>
			<div class="icon" @click="showAdvert = false"><a-icon type="close" :style="{fontSize:'20px',color:'#666'}" /></div>
		</div>
		<div class="advert" v-if="jumpImageList[0]['linkType']==2 && showAdvert == true">
			<router-link :to="jumpImageList[0]['linkUrl']">
				<img :src="imagePath + jumpImageList[0]['imageUrl']" alt="">
			</router-link>
			<div class="icon" @click="showAdvert = false"><a-icon type="close" :style="{fontSize:'20px',color:'#666'}" /></div>
		</div>

		<!-- 业务办理 -->
		<div class="processing">
			<a-popover placement="left">
				<template slot="content">
					<div class="menu">
						<router-link  v-for="(item,index) in popmenuList" :key="index" :to="item.jumpRoute">
							<div class="menu-item">{{item.menuName}}</div>
						</router-link>
					</div>
				</template>
				<div class="item">
					<a-icon type="search" :style="{fontSize:'30px',color:'#666'}" />
					<div class="margin-top-5">业务办理</div>
				</div>
			</a-popover>
		</div>

		<!-- 轮播图 -->
		<div class="swiper">
			<a-carousel :dots="false" :after-change="carouselChange" ref="carousel">
				<div v-for="(item,index) in swiperList" :key="index">
					<router-link :to="item.linkUrl">
						<img class="banner" :src="$api.baseUrl+$api.imgPath+item.pcImageUrl" alt="">
					</router-link>
				</div>
			</a-carousel>
			<div class="container" style="margin-top: 50px;">
				<div class="dot">
					<span class="current_dot">{{current_dot}}</span>
					<span class="gap">/</span>
					<span class="all_dot">{{swiperList.length}}</span>
				</div>
				<div class="btns">
					<a @click="toPrev"><img src="../assets/banner_to_left.png" alt=""></a>
					<a @click="pauseCarousel" v-if="swiperAuto" class="circle">
						<img src="../assets/pause.png" width="18" alt="">
					</a>
					<a @click="carouselAutoPlay" v-else class="circle">
						<img src="../assets/play.png" width="18" alt="">
					</a>
					<a @click="toNext"><img src="../assets/banner_to_right.png" alt=""></a>
				</div>

			</div>
		</div>
		<div class="container search" style="display: none;">
			<div class="business">
				<div style="width: 750px;">
					<div class="flex justify-around align-center">
						<div class="item"><img width="42" src="@/assets/企业挂牌.png" alt=""><a
								class="color-333 margin-left-10" href="">企业挂牌</a></div>
						<div class="line"></div>
						<div class="item"><img width="36" src="@/assets/登记托管.png" alt=""><a
								class="color-333 margin-left-10" href="">登记托管</a></div>
						<div class="line"></div>
						<div class="item"><img width="40" src="@/assets/企业融资.png" alt=""><a
								class="color-333 margin-left-10" href="">企业融资</a></div>
						<div class="line"></div>
						<div class="item"><img width="40" src="@/assets/企业融资.png" alt=""><a
								class="color-333 margin-left-10" href="">企业融资</a></div>
					</div>
					<div class="flex justify-around align-center margin-top-15">
						<div class="item"><img width="40" src="@/assets/金融资产.png" alt=""><a
								class="color-333 margin-left-10" href="">金融资产</a></div>
						<div class="line"></div>
						<div class="item"><img width="38" src="@/assets/股权估值.png" alt=""><a
								class="color-333 margin-left-10" href="">股权估值</a></div>
						<div class="line"></div>
						<div class="item"><img width="38" src="@/assets/信息披露.png" alt=""><a
								class="color-333 margin-left-10" href="">信息披露</a></div>
						<div class="line"></div>
						<div class="item"><img width="38" src="@/assets/信息披露.png" alt=""><a
								class="color-333 margin-left-10" href="">信息披露</a></div>
					</div>
				</div>
				<div class="item2"><a class="color-333" href="">
						<div>河北省企业</div>
						<div>股改上市服务平台</div>
					</a></div>
			</div>
		</div>

		<!-- 动态 -->
		<div class="active-box">
			<div class="container">
				<a-spin :spinning="loading">
					<div class="flex justify-between">
						<!-- <newsSwiper style="" :list="newsSwiper" :type="1" width="534px" height="382px" radius="8px"></newsSwiper> -->
						<div class="news-list news1">
							<a-tabs v-model="currentTab" type="card" @change="tabChange" @tabClick="toNewsList"
								ref="tabs">
								<a-tab-pane v-for="(item,index) in newsList" :key="index" :tab="item.newsType.newsType">
									<div style="margin-top:-15px;background-color: #fff;min-height: 378px;">
										<div class="news-item flex justify-between"
											v-for="(news,newsIndex) in item.pageList.records">
											<router-link class="overflow-eli font-16"
												:to="{path:'/news/info',query:{newsId:news.id}}">
												· {{news.newsTitle}}
											</router-link>
											<span style="width:140px;text-align: right;">{{news.releaseTime}}</span>
										</div>
									</div>
								</a-tab-pane>
							</a-tabs>
						</div>
						<div class="news-list news2">
							<a-tabs v-model="rightTab" type="card" @change="rightTabChange" @tabClick="toNewsRightList"
								ref="tabs">
								<a-tab-pane v-for="(item,index) in newsListRight" :key="index"
									:tab="item.newsType.newsType">
									<div style="margin-top:-15px;background-color: #fff;min-height: 378px;">
										<div class="news-item flex justify-between"
											v-for="(news,newsIndex) in item.pageList.records">
											<router-link class="overflow-eli font-16"
												:to="{path:'/news/info',query:{newsId:news.id}}">
												· {{news.newsTitle}}
											</router-link>
											<span style="width:140px;text-align: right;">{{news.releaseTime}}</span>
										</div>
									</div>
								</a-tab-pane>
							</a-tabs>
						</div>
					</div>
				</a-spin>
			</div>
		</div>

		<!-- 数据区域 -->
		<div>
			<div style="overflow:hidden;width:100%;margin:0 auto;min-height:800px;text-align:center" id="hiddenBox">
				<iframe src="http://biz.hebotc.com/#/officialWebsiteMapChart" scrolling="no" height="800"
					frameborder="0" width="100%"></iframe>
			</div>
		</div>
		<!-- 中间横幅 -->
		<div class="banner-cneter">
			<img width="100%" height="150" style="object-fit: cover;" src="../assets/banner_center.png" alt="">
		</div>
		<!-- 数据区域2 -->
		<div class="">
			<div style="overflow:hidden;width:100%;margin:0 auto;min-height:250px;text-align:center">
				<iframe src="http://biz.hebotc.com/#/officialWebsiteTables" scrolling="no" frameborder="0" height="500"
					width="1200"></iframe>
			</div>
		</div>
		<!-- 特色板块 -->
		<div class="spical">
			<div class="container">
				<div class="title-box flex align-center">
					<div class="titles"></div>
					<div class="title">特色板块</div>
				</div>
				<div class="content">
					<div v-for="(item,index) in spicalList" :key="index">
						<div class="item active" v-if="item.show"
							:style="`background: url(${$api.baseUrl+$api.imgPath+item.backgroundUrl})`"
							@click="toSpicalInfo(item.id)" @mouseenter="spicalShow(index)">
							<div class="num">0{{index+1}}</div>
							<div class="item-title">{{item.plate}}</div>
							<div class="line"></div>
							<div class="content" v-if="item.show">{{item.plateContent}}</div>
							<div class="icon"><img
									:src="item.show?$api.baseUrl+$api.imgPath+item.iconFalse:$api.baseUrl+$api.imgPath+item.iconTrue"
									alt=""></div>
						</div>
						<div class="item" v-else @click="toSpicalInfo(item.id)" @mouseenter="spicalShow(index)">
							<div class="num">0{{index+1}}</div>
							<div class="item-title">{{item.plate}}</div>
							<div class="line"></div>
							<div class="content" v-if="item.show">{{item.plateContent}}</div>
							<div class="icon">
								<img :src="item.show?$api.baseUrl+$api.imgPath+item.iconFalse:$api.baseUrl+$api.imgPath+item.iconTrue"
									alt="">
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
		<!-- 友情链接 -->
		<div class="fav-link">
			<div class="container">
				<div class="title-box flex align-center justify-between">
					<div class="flex align-center">
						<div class="titles"></div>
						<div class="title">友情链接</div>
					</div>
					<!-- <div>
						<a @click="prevLink"><img src="../assets/friend_left.png" alt=""></a>
						<a @click="nextLink" style="margin-left:10px;"><img src="../assets/friend_right.png"></a>
					</div> -->
				</div>
				<!-- <a-carousel style="width:1200px;" ref="friendCarousel">
					<div class="" v-for="(item,index) in friendLink" :key="index">
						<div class="flex justify-between">
							<a :href="child.linkUrl" v-for="(child,childIndex) in item" :key="childIndex" target="_blank">
								<div class="item">
									<img width="180" :src="$api.baseUrl+$api.imgPath+child.pcImageUrl" alt="">
								</div>
							</a>
						</div>
					</div>
				</a-carousel> -->
				<vue-seamless-scroll :data="friendLink" :class-option="seamlessScrollOption">
					<!-- <div style="100%" class="flex justify-between" v-for="(item,index) in friendLink" :key="index">
						<a :href="item.linkUrl" target="_blank">
							<div class="item">
								<img width="180" :src="$api.baseUrl+$api.imgPath+item.pcImageUrl" alt="">
							</div>
						</a>
					</div> -->
					<div class="firend_link">
						<a class="padding-10" :href="item.linkUrl" target="_blank" v-for="(item,index) in friendLink"
							:key="index">
							<img width="180" :src="$api.baseUrl+$api.imgPath+item.pcImageUrl" alt="">
						</a>
					</div>
				</vue-seamless-scroll>
			</div>
		</div>

		<BaseFooter></BaseFooter>
	</div>
</template>

<script>
	import vueSeamlessScroll from 'vue-seamless-scroll'
	import BaseNav from "@/components/BaseNavigation"
	import BaseFooter from "@/components/BaseFooter"
	import newsSwiper from "@/components/NewsSwiper"
	export default {
		components: {
			BaseNav,
			BaseFooter,
			newsSwiper,
			vueSeamlessScroll
		},
		computed: {
			seamlessScrollOption() {
				return {
					step: 0.2, // 数值越大速度滚动越快
					limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
					hoverStop: true, // 是否开启鼠标悬停stop
					direction: 2, // 0向下 1向上 2向左 3向右
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
				};
			}
		},
		data() {
			return {
				loading: true,
				swiperList: [],
				businessBg: "",
				newsSwiper: [], //推荐新闻轮播图
				newsList: [], //新闻列表
				newsListRight: [],
				spicalList: [], //特色板块
				friendLink: [], //友情链接
				current_dot: 1,
				swiperAuto: true,
				menuPosition: "1481846823343697922",
				timer: "",
				newsTimer: "",
				keywords: "", //搜索内容
				currentTab: 0,
				rightTab: 0,
				businessList: [],
				currentBusiness: {},
				imagePath: this.$api.baseUrl + this.$api.imgPath,
				jumpImageList: [],
				popmenuList:[],
				showAdvert:true,
			}
		},
		created() {
			document.title = "雄安股权交易所-首页";
		},
		mounted() {
			let that = this;
			setTimeout(() => {
				this.getTopBanner(); //首页banner获取
			}, 500)
			this.queryBusinessList();
			this.getFriendLink(); //首页友情链接获取
			this.getSpecial(); //获取特色板块
			this.getHomeRecommendNews(); //推荐新闻（轮播图）
			this.getHomeNews(); //获取首页新闻
			this.getHomeNewsRight();
			this.queryPopMenuList();
			this.queryJumpImageList();
			setTimeout(() => {

				this.$nextTick(() => {
					var target = document.querySelector(".news1").querySelectorAll(".ant-tabs-tab")
					for (let i = 0; i < target.length; i++) {
						target[i].addEventListener("mouseenter", (e) => {
							that.currentTab = i;
						})
					}
				})

				this.$nextTick(() => {
					var target = document.querySelector(".news2").querySelectorAll(".ant-tabs-tab")
					for (let i = 0; i < target.length; i++) {
						target[i].addEventListener("mouseenter", (e) => {
							that.rightTab = i;
						})
					}
				})

				// this.nextLink();
			}, 1000)


		},
		methods: {
			//获取弹窗广告
			queryJumpImageList() {
				this.$request({
					url: this.$api.public.queryJumpImageList,
				}).then((res) => {
					this.jumpImageList = res.data.result;
				})
			},
			queryPopMenuList(){
				this.$request({
					url:this.$api.public.queryPopMenuList
				}).then((res)=>{
					this.popmenuList = res.data.result;
				})
			},
			changeBusiness(item) {
				this.currentBusiness = item;
			},
			// 获取业务介绍
			queryBusinessList() {
				this.$request({
					url: this.$api.home.queryBusinessList,
				}).then((res) => {
					this.businessList = res.data.result;
					this.currentBusiness = this.businessList[0];
				})
			},
			jumpFirendLink(url) {
				console.log(url);
				window.open(url, '_blank');
			},
			prevLink() {
				this.$refs.friendCarousel.prev()
			},
			nextLink() {
				this.$refs.friendCarousel.next()
			},
			// 特色详情跳转
			toSpicalInfo(id) {
				this.$router.push({
					path: '/special/info/' + id
				});
			},
			//特色板块切换
			spicalShow(index) {
				this.spicalList.forEach((item) => {
					item.show = false;
				});
				this.spicalList[index].show = true;
			},
			// 搜索按钮
			doSearch() {
				this.$router.push({
					path: "/searchNews",
					query: {
						keywords: this.keywords
					}
				});
			},
			toNewsList(index) {
				let news = this.newsList[index].newsType;
				if (this.newsList[index].newsType.id == "1519128438568374274") {
					this.$router.push({
						path: "/property",
						query: {
							menuPosition: "1492378541355991041"
						}
					})
					return false;
				}
				this.$router.push({
					path: "/news/list",
					query: {
						homeMenuFirstId: news.homeMenuFirstId,
						menuPosition: this.menuPosition,
						newsType: news.id
					}
				})
			},
			toNewsRightList(index) {
				let news = this.newsListRight[index].newsType;
				if (this.newsListRight[index].newsType.id == "1519128438568374274") {
					this.$router.push({
						path: "/property",
						query: {
							menuPosition: "1492378541355991041"
						}
					})
					return false;
				}
				this.$router.push({
					path: "/news/list",
					query: {
						homeMenuFirstId: news.homeMenuFirstId,
						menuPosition: this.menuPosition,
						newsType: news.id
					}
				})
			},
			tabMouseEnter(e) {
				console.log(e)
			},
			// tab切换事件
			tabChange() {

			},
			rightTabChange() {

			},
			// 幻灯片上一张
			toPrev() {
				this.$refs.carousel.prev();
			},
			//幻灯片下一张
			toNext() {
				this.$refs.carousel.next();
			},
			// 幻灯片暂停
			pauseCarousel() {
				this.swiperAuto = false;
				clearInterval(this.timer);
				this.timer = "";
			},
			// 幻灯片切换后事件
			carouselChange(e) {
				this.current_dot = e + 1;
			},
			//幻灯片播放
			carouselAutoPlay() {
				this.swiperAuto = true;
				let that = this;
				this.timer = setInterval(() => {
					that.$refs.carousel.next();
				}, 5000);
			},
			// 首页顶部轮播图
			getTopBanner() {
				this.$request({
					url: this.$api.public.getBanner,
					data: {
						menuPosition: this.menuPosition,
						type: 1
					}
				}).then((res) => {
					this.swiperList = res.data.result;
					setTimeout(() => {
						this.carouselAutoPlay();
					}, 1000)
				})
			},
			//首页推荐新闻（轮播图）
			getHomeRecommendNews() {
				this.$request({
					url: this.$api.home.getHomeRecommendNews,
				}).then((res) => {
					this.newsSwiper = res.data.result;
				})
			},
			//获取特色板块
			getSpecial() {
				this.$request({
					url: this.$api.home.getSpecial,
				}).then((res) => {
					let _result = res.data.result;
					_result.forEach((item) => {
						item.show = false;
					})
					_result[0].show = true;
					this.spicalList = _result;
				});
			},
			getHomeNews() {
				this.$request({
					url: this.$api.home.getHomeNews,
					data: {
						newsTypes: 3
					}
				}).then((res) => {
					this.newsList = res.data.result;
					this.loading = false;
				})
			},
			getHomeNewsRight() {
				this.$request({
					url: this.$api.home.getHomeNews,
					data: {
						newsTypes: 1
					}
				}).then((res) => {
					this.newsListRight = res.data.result;
					this.loading = false;
				})
			},
			// 获取友情链接
			getFriendLink() {
				this.$request({
					url: this.$api.home.getFrindLink,
				}).then((res) => {
					let _result = res.data.result;
					this.friendLink = _result;
				});
			},
		}
	}
</script>

<style scoped="scoped">
	.swiper {
		height: 494px;
		position: relative;
	}

	.firend_link {
		/* width: 100%; */
		margin-top: 14px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	.swiper .banner {
		width: 100%;
		min-width: 1200px;
		height: 494px;
		object-fit: cover;
	}

	.swiper .container {
		position: relative;
	}

	.business {
		display: flex;
		background-color: white;
		/* height: 100%; */
		padding: 5px;
		box-shadow: 0px 0px 8px rgba(30, 34, 170, 0.08);
		border-radius: 8px;
		justify-content: space-between;
		align-items: center;
		font-size: 18px;
		font-weight: bold;
	}

	.business .line {
		height: 24px;
		background-color: #ededed;
		width: 1px;
	}

	.business .item {
		background-color: white;
		padding: 0px;
		font-size: 20px;
		letter-spacing: 2px;
		/* box-shadow: 0px 0px 8px rgba(30, 34, 170, 0.08); */
		border-radius: 4px;
	}



	.business .item2 {
		background-color: white;
		padding: 5px;
		/* box-shadow: 0px 0px 8px rgba(30, 34, 170, 0.08); */
		border-radius: 4px;
		width: 210px;
		height: 100px;
		display: flex;
		align-items: center;
		letter-spacing: 3px;
		justify-content: center;
		text-align: center;
	}

	.dot {
		position: absolute;
		bottom: 76px;
		color: white;
		font-size: 16px;
	}

	.dot .current_dot {
		font-size: 36px;
	}


	.yewu {
		margin-top: 70px;
		padding-bottom: 70px;
	}

	.yewu .box {
		width: 1200px;
		height: 600px;
		position: relative;
		overflow: hidden;
		/* background: url(../assets/yewu_bg.png); */
	}

	.yewu .box .contents {
		width: 700px;
		margin-left: auto;
		margin-right: auto;
		text-align: center;
	}

	.yewu .box a {
		display: block;
		width: 160px;
		height: 38px;
		background: rgba(0, 0, 0, 0.02);
		opacity: 1;
		border-radius: 42px;
		color: white;
		display: flex;
		justify-content: center;
		align-items: center;
		border: 1px solid #FFFFFF;
		margin-left: auto;
		margin-right: auto;
		margin-top: 40px;
	}

	.yewu .box .contents .titles {
		color: white;
		font-size: 30px;
		margin-top: 80px;
	}

	.yewu .box .contents .line {
		width: 20px;
		height: 4px;
		background: #FFFFFF;
		border-radius: 2px 2px 2px 2px;
		opacity: 1;
		margin-left: auto;
		margin-right: auto;
		margin-top: 30px;
		margin-bottom: 30px;
	}

	.yewu .box .contents .desc {
		color: white;
		font-size: 18px;
		line-height: 35px;
	}

	.yewu .box .bottom-nav {
		width: 100%;
		position: absolute;
		bottom: 0;

		background: rgba(26, 26, 26, 0.6);
		display: flex;
		justify-content: space-between;
	}

	.yewu .box .bottom-nav .item {
		color: #B3B3B3;
		padding: 25px;
		font-size: 14px;
		cursor: pointer;
	}

	.yewu .box .bottom-nav .item-active {
		color: #13B8EE;
		border-top: 1px solid #13B8EE;
	}

	.swiper .btns {
		position: absolute;
		display: flex;
		align-items: center;
		bottom: 76px;
		right: 0;
	}

	.search {
		position: relative;
		margin-top: -55px;
		width: 1000px;
		z-index: 99999;
	}

	.search-box {
		width: 1200px;
		border-radius: 8px;
		padding: 25px;
		top: -130px;
		background-color: #FFFFFF;
		box-shadow: 0px 0px 8px rgba(30, 34, 170, 0.08);
		z-index: 999;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.input-search {
		margin-left: 30px;
		font-size: 18px;
		border: none;
		outline: none !important;
		width: 1000px;
	}

	.ant-divider,
	.ant-divider-vertical {
		height: 1.1em;
	}

	.search-btn {
		color: #333333;
		font-weight: 500;
		font-size: 20px;
	}

	.swiper .btns .circle {
		display: block;
		width: 27px;
		height: 27px;
		border-radius: 50%;
		border: 2px solid #F0F0F0;
		text-align: center;
		margin-left: 5px;
		margin-right: 5px;
	}

	.swiper .btns .anticon {
		margin-right: 6px;
		font-size: 24px;
	}

	.active-box {
		/* padding-top: 70px; */
		/* padding-bottom: 10px; */
		/* background-color: #f1f2f7; */
		margin-top: 40px;
		position: relative;
	}

	.active-box .container {
		/* margin-top: 90px; */
	}

	.news-list {
		width: 590px;
		height: 415px;
		overflow: hidden;
	}

	.news-list .news-item {
		padding: 20px 15px;
		border-bottom: 1px dotted #D9D9D9;
		font-size: 16px;
		transition: all 0.3s;
		background-color: #FFFFFF;
	}

	.news-list .news-item:nth-of-type(1) a {
		font-size: 18px;
		font-weight: bold;
		color: #13B8EE;
	}

	.news-list .news-item:nth-of-type(1):hover a {
		color: #13B8EE;
	}

	.news-list .news-item:hover {
		border-bottom: 1px dotted #13B8EE;
	}

	.news-list .news-item:hover a {
		color: #13B8EE;
	}

	.news-list .news-item a {
		color: #1A1A1A;
	}


	.spical {
		height: 372px;
		background-color: #f1f2f7;
	}

	.spical .titles {
		width: 4px;
		height: 24px;
		background: linear-gradient(180deg, #1E22AA 0%, #0CB2EC 100%);
		opacity: 1;
		border-radius: 0px;
	}

	.spical .content {
		width: 1200px;
		height: 400px;
		margin-top: 20px;
		display: flex;
	}


	.spical .content .item {
		width: 170px;
		height: 400px;
		border-right: 1px solid #E6E6E6;
		background: linear-gradient(180deg, #FCFDFF 0%, #FFFFFF 78%, #F0F2FE 100%);
		display: flex;
		flex-flow: column nowrap;
		align-items: center;
		cursor: pointer;
		transition: all 0.3s;
	}


	.spical .content .item:nth-of-type(5) {
		border-right: none;
	}

	.spical .content .item .num {
		margin-top: 50px;
		font-size: 12px;
		color: #1A1A1A;
	}

	.spical .content .item .item-title {
		color: #1A1A1A;
		font-size: 20px;
		margin-top: 16px;
	}

	.spical .content .item .line {
		width: 16px;
		height: 3px;
		background: #E6E6E6;
		opacity: 1;
		border-radius: 0px;
		margin-top: 32px;
	}

	.spical .content .item .icon {
		margin-top: 177px;
	}


	.spical .content .active {
		width: 525px;
		height: 400px;
		border-right: 1px solid #E6E6E6;
		/* background: url(../assets/spical_bg.png); */
		display: flex;
		flex-flow: column nowrap;
		align-items: flex-start;
	}

	.spical .content .active .num {
		color: #FFFFFF;
		margin-left: 50px;
	}

	.spical .content .active .item-title {
		color: #FFFFFF;
		margin-left: 50px;
	}

	.spical .content .active .line {
		width: 16px;
		height: 3px;
		background: #13B8EE;
		opacity: 1;
		border-radius: 0px;
		margin-left: 50px;
	}

	.spical .content .active .content {
		width: 420px;
		height: 100px;
		margin-left: 50px;
		color: #FFFFFF;
	}

	.spical .content .active .icon {
		margin-top: 35px;
		margin-left: 50px;
	}

	.spical .title {
		font-size: 24px;
		font-weight: 500;
		margin-left: 12px;
	}

	.spical .title-box {
		padding-top: 20px;
	}


	.fav-link {
		height: 317px;
		overflow: hidden;
	}

	.fav-link .container {
		overflow-x: hidden;
		overflow: hidden;
	}


	.fav-link .title-box {
		margin-top: 125px;
	}

	.fav-link .title {
		font-size: 24px;
		font-weight: 500;
		margin-left: 12px;
	}

	.fav-link .titles {
		width: 4px;
		height: 24px;
		background: linear-gradient(180deg, #1E22AA 0%, #0CB2EC 100%);
		opacity: 1;
		border-radius: 0px;
	}

	.fav-link .item {
		margin-top: 20px;
		/* width: 220px; */
		height: 118px;
		position: relative;
		z-index: 9999;
		cursor: pointer;
	}

	.banner-cneter {
		margin-top: -5px;
	}

	.advert {
		width: 88px;
		position: fixed;
		top: 30%;
		left: 10px;
		z-index: 99999;
	}

	.advert img {
		width: 88px;
	}
	
	.advert .icon{
		position: absolute;
		top:10px;
		right:10px;
	}

	.processing {
		position: fixed;
		right: 0;
		top: 50%;
		z-index: 999;
		background-color: white;
		box-shadow: 0px 0px 10px 3px rgba(0, 0, 0, 0.1);
	}

	.processing .item {
		width: 100px;
		height: 100px;
		display: flex;
		flex-flow: column;
		justify-content: center;
		align-items: center;
		border-bottom: 1px solid #ededed;
	}
	
	
	.menu{
		width:180px;
		display: flex;
		flex-flow: row wrap;
		justify-content: space-between;
	}
	
	
	.menu .menu-item{
		background-color: #D9D9D9;
		padding:10px 15px;
		margin-bottom: 10px;
		font-weight: bold;
		color: #1A1A1A;
	}
</style>
<style type="text/css">
	.news-list .ant-tabs-bar {
		border: none !important;
	}

	.news-list .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-nav-container {
		height: auto;
	}

	.news-list .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
		font-size: 20px;
		margin-left: 10px;
		margin-right: 10px;
		color: #666666;
		height: auto;
		padding: 6px 20px;
		background: none;
		border: none;
	}

	.news-list .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
		border: none !important;
		color: #FFFFFF;
		background-color: #13B8EE;
		border-radius: 8px 8px 0px 0px;
	}

	.ant-spin-container {}
</style>


// WEBPACK FOOTER //
// src/pages/index.vue